import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RightCircleFilledSvg from "@ant-design/icons-svg/es/asn/RightCircleFilled";
import AntdIcon from "../components/AntdIcon";
var RightCircleFilled = function RightCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RightCircleFilled.displayName = 'RightCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(RightCircleFilled);